<template>
  <AccountOpePanel>
    <div class="aiz-titlebar mt-2 mb-4">
      <div class="row align-items-center">
        <div class="col-md-6">
          <b class="h4">{{ $t("愿望清单") }}</b>
        </div>
      </div>
    </div>
    <div v-if="list && list.length" class="row gutters-5">
      <div
        v-for="item in list"
        :key="item.id"
        class="col-xxl-3 col-xl-4 col-lg-3 col-md-4 col-sm-6"
      >
        <div class="card mb-2 shadow-sm">
          <div class="card-body">
            <router-link
              :to="`/product?goodsId=${item.goodsId}&shopId=${item.shopId}`"
              class="d-block mb-3"
            >
              <img
                :alt="$t(item.goodsName)"
                :src="getFileViewUrl(item.goodsPic)"
                class="img-fit2 h-140px h-md-200px"
              />
            </router-link>

            <h5 class="fs-14 mb-0 lh-1-5 fw-600 text-truncate-2">
              <router-link
                :to="`/product?goodsId=${item.goodsId}&shopId=${item.shopId}`"
                class="text-reset"
                >{{ item.goodsName }}
              </router-link>
            </h5>
            <!--            <StarsComp :star="item.star" />-->
            <div class=" fs-14">
              <span class="fw-600 text-primary">{{
                formatMoney(item.goodsPrice)
              }}</span>
            </div>
          </div>
          <div class="card-footer">
            <a
              class="link link--style-3"
              data-placement="top"
              data-toggle="tooltip"
              href="#"
              title="Remove from wishlist"
              @click="removeFromWishlist(item.id)"
            >
              <i class="la la-trash la-2x"></i>
            </a>
            <button
              class="btn btn-sm btn-block btn-primary ml-3"
              type="button"
              @click="addToCart(item)"
            >
              <i class="la la-shopping-cart mr-2"></i>{{ $t("添加到购物车") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="row gutters-5">
      <div class="col">
        <div class="text-center bg-white p-4 rounded shadow">
          <img
            alt="Image"
            class="mw-100 h-200px"
            src="/static/assets/img/nothing.svg"
          />
          <h5 class="mb-0 h5 mt-3">
            {{ $t("还没有添加任何东西") }}
          </h5>
        </div>
      </div>
    </div>
  </AccountOpePanel>
</template>
<script>
import AccountOpePanel from "@/components/AccountOpePanel.vue";

export default {
  components: { AccountOpePanel },
  computed: {
    list() {
      return this.$store.state.user.wishList;
    }
  },
  methods: {
    removeFromWishlist(id) {
      this.$store.dispatch("user/deleteFromWishList", id);
    },
    addToCart(item) {
      this.gotToProduct(item.goodsId, item.shopId);
    }
  }
};
</script>
